import { render } from "./StrDiff.vue?vue&type=template&id=55b43cc2&scoped=true"
import script from "./StrDiff.vue?vue&type=script&lang=js"
export * from "./StrDiff.vue?vue&type=script&lang=js"

import "./StrDiff.vue?vue&type=style&index=0&id=55b43cc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b43cc2"]])

export default __exports__